import React from 'react'
import PropTypes from 'prop-types'
import focusable from '../../components/Focusable/Focusable'
import StationPassportTitle from '../../components/StationPassportTitle/StationPassportTitle'
import FocusableButton from '../../components/FocusableButton/FocusableButton'
import FocusableInput from '../../components/FocusableInput/FocusableInput'
import NumericKeyboard from '../../components/NumericKeyboard/NumericKeyboard'
import tts from '../../lib/TTS'
import { MONTHLY } from '../../lib/ComcastBilling'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

const MAX_MONTHLY_DONATION = 20
const MAX_ONE_TIME_DONATION = 100
const DEFAULT_MINIMUM_AMOUNT = 1

export const CUSTOM = 'custom'

class CustomAmountScreen extends React.Component {
  constructor(props) {
    super(props)
    this.confirmRef = React.createRef()
    this.inputRef = React.createRef()
    this.state = {
      error: '',
      showKeyboard: false,
      donation: 0,
      formattedDonation: '0.00',
    }
    this.donationFrequency = this.props.router.params?.frequency
    this.stationName = this.props.station.short_common_name
    this.stationLearnMoreUrl =
      this.props.station.passport_learn_more_url ||
      'https://pbs.org/passport/learn-more'
    this.mininumDonationAllowed =
      this.donationFrequency === MONTHLY
        ? +this.props.station.donation_campaign?.minimum_monthly_amount ||
          DEFAULT_MINIMUM_AMOUNT
        : +this.props.station.donation_campaign?.minimum_amount ||
          DEFAULT_MINIMUM_AMOUNT
    this.formattedMininumDonationAllowed =
      this.mininumDonationAllowed.toFixed(2)
  }

  componentDidMount() {
    tts.stopRead()
    setTimeout(() => {
      this.inputRef.current.setFocus()
    }, 500)

    googleAnalytics4.sendPageViewEvent('Custom Donation')
  }

  onKeyEvent(key) {
    let handled = false

    if (key === 'BACK') {
      this.props.router.navigate(-1)
    }

    if (key === 'DOWN') {
      this.confirmRef.current.setFocus()
      handled = true
    } else if (key === 'UP') {
      this.inputRef.current.setFocus()
      handled = true
    }
    return handled
  }

  showKeyboard = () => this.setState({ showKeyboard: true })

  handleConfirmDonation = () => {
    const { donation, formattedDonation } = this.state
    let maxToUse = MAX_ONE_TIME_DONATION
    let minToUse = this.mininumDonationAllowed

    let errorMin = `Please enter a donation of $${this.formattedMininumDonationAllowed} or more to gain access to ${this.stationName} Passport member benefit.`
    let errorMax = `The donation amount must be $${maxToUse} or less. <br/><br/>
    If you would like to donate more to ${this.stationName}, please visit <span>${this.stationLearnMoreUrl}</span> on your computer or phone.`
    let error = null
    if (this.donationFrequency === MONTHLY) {
      maxToUse = MAX_MONTHLY_DONATION
      errorMin = `Please enter a donation of $${this.formattedMininumDonationAllowed}/month or more to gain access to ${this.stationName} Passport member benefit.`
      errorMax = `The donation amount must be $${maxToUse} or less per month. <br/><br/> If you would like to donate more to ${this.stationName}, please visit <span>${this.stationLearnMoreUrl}</span> on your computer or phone.`
    }
    let errorType
    if (donation > maxToUse) {
      errorType = 'above_max'
      error = errorMax
    } else if (donation < minToUse) {
      errorType = 'below_min'
      error = errorMin
    }
    if (error) {
      googleAnalytics4.sendCustomEvent(
        'custom_donation_amount_error',
        {
          donation_type: CUSTOM,
          donation_frequency:
            this.donationFrequency === MONTHLY ? 'monthly' : 'one-time',
          attempted_amount: formattedDonation,
          custom_donation_error_type: errorType,
        },
        'Custom Donation Amount Screen'
      )

      this.setState({ error })
      const sanitizedError = error.replace(/<[^>]+>/g, '')
      tts.addTextToRead(sanitizedError)
    } else {
      this.props.executeDonationProcess({
        totalChargeAmount: formattedDonation,
        donationFrequency: this.donationFrequency,
        donationType: CUSTOM,
      })
    }
  }

  handleClose = () => {
    this.setState({ showKeyboard: false })
    this.inputRef.current.setFocus()
  }

  handleConfirm = (value, formattedValue) => {
    this.setState({
      donation: value,
      formattedDonation: formattedValue,
      error: '',
    })
  }

  render() {
    return (
      <>
        <NumericKeyboard
          show={this.state.showKeyboard}
          onClose={this.handleClose}
          onConfirmedValue={this.handleConfirm}
        />
        <div className="custom-amount-screen">
          <StationPassportTitle
            className="header"
            stationTitle={this.stationName}
          />
          <p className="info">
            A donation of ${this.formattedMininumDonationAllowed}
            {this.donationFrequency === MONTHLY && '/month'} or more is required
            to gain access to the {this.stationName} Passport member benefit.
          </p>
          <div className="input-container">
            <label>
              Enter{' '}
              {this.donationFrequency === MONTHLY ? 'monthly' : 'one-time'}{' '}
              donation amount
            </label>
            <FocusableInput
              className={`input-box ${this.state.error && 'error2'}`}
              ref={this.inputRef}
              value={`$${this.state.formattedDonation}`}
              parent={this}
              onClick={this.showKeyboard}
              onFocused={() =>
                tts.addTextToRead(
                  `Enter ${
                    this.donationFrequency === MONTHLY ? 'monthly' : 'one-time'
                  } donation amount`
                )
              }
            />
            <div className="confirmation-button">
              <FocusableButton
                parent={this}
                onClick={this.handleConfirmDonation}
                componentType="ConfirmKey"
                ref={this.confirmRef}
                onFocused={() =>
                  tts.addTextToRead(
                    `Focused on ${this.confirmRef.current?.props.children.join(
                      ''
                    )} `
                  )
                }
              >
                Confirm{' '}
                {this.donationFrequency === MONTHLY ? 'monthly' : 'one-time'}{' '}
                donation
              </FocusableButton>
            </div>
          </div>
          <p
            className="error"
            dangerouslySetInnerHTML={{ __html: this.state.error }}
          />
        </div>
      </>
    )
  }
}

CustomAmountScreen.propTypes = {
  station: PropTypes.shape({
    short_common_name: PropTypes.string,
    passport_learn_more_url: PropTypes.string,
    donation_campaign: PropTypes.shape({
      minimum_amount: PropTypes.string,
      minimum_monthly_amount: PropTypes.string,
    }),
  }),
  router: PropTypes.shape({
    navigate: PropTypes.func,
    params: PropTypes.shape({ frequency: PropTypes.string }),
  }),
  executeDonationProcess: PropTypes.func,
}

export default withRouter(focusable(CustomAmountScreen))
